import React                                from 'react';
import AuthService                          from './AuthService';
import Grid                                 from '@material-ui/core/Grid';
import { Redirect}                          from 'react-router-dom';
import { withStyles }                       from '@material-ui/core/styles';
import Menus                                from './components/Menu';
import AppBar                               from '@material-ui/core/AppBar';
import GridListTileBar                      from '@material-ui/core/GridListTileBar';
import Typography                           from '@material-ui/core/Typography';
import Tooltip                              from '@material-ui/core/Tooltip';
import Toolbar                              from '@material-ui/core/Toolbar';
import IconButton                           from '@material-ui/core/IconButton';
import Pagina                               from './components/Paginas';
import Paper                                from '@material-ui/core/Paper';
import Tabs                                 from '@material-ui/core/Tabs';
import Tab                                  from '@material-ui/core/Tab'; 
import Box                                  from '@material-ui/core/Box';
import Iconos                               from '../src/components/Icono';
import Card                                 from '@material-ui/core/Card';
import CardHeader                           from '@material-ui/core/CardHeader';
import CardActions                          from '@material-ui/core/CardActions';
import CardContent                          from '@material-ui/core/CardContent';
import CardMedia                            from '@material-ui/core/CardMedia';
import { Divider }                          from '@material-ui/core';
import Backdrop                             from '@material-ui/core/Backdrop';
import Badge                                from '@material-ui/core/Badge';
import Dialog                               from '@material-ui/core/Dialog';
import DialogContent                        from '@material-ui/core/DialogContent';
import {colores,funciones,globales,pendientes_alumno,usuario}       from './global'
import { MuiThemeProvider }                 from '@material-ui/core/styles';
import Fab                                  from '@material-ui/core/Fab';
import LinearProgress                       from '@material-ui/core/LinearProgress';
import Radio                                from '@material-ui/core/Radio';
import RadioGroup                           from '@material-ui/core/RadioGroup';
import FormControlLabel                     from '@material-ui/core/FormControlLabel';
import FormControl                          from '@material-ui/core/FormControl';
import Avatar                               from '@material-ui/core/Avatar';
import Request                              from 'superagent';
import                                            './CSS/Style_principal.css';
import BarraBotones                         from './components/Barra_menu';
import DialogTitle                          from '@material-ui/core/DialogTitle';
import CircularProgress                     from '@material-ui/core/CircularProgress';
import CardActionArea                       from '@material-ui/core/CardActionArea';
import Widgets                              from './components/Widgets'
import Mensajes                             from './components/Mensajes';
import Slide                                from '@material-ui/core/Slide';
import Button                               from '@material-ui/core/Button';
import {theme}                              from './themeMui';
import Skeleton                             from '@material-ui/lab/Skeleton';
import queryString                          from 'query-string';
import { Checkmark }                        from 'react-checkmark';
import CloseIcon                            from '@material-ui/icons/Close';

/*-----------------------------------------INFORMACION---------------------------------------*/

//------------lista_tabpanel: Contiene el valor original de las tabs abiertas
//------------this.lista_tabpanel: Contiene las tabs que ya renderizaron y las que no

let Auth = new AuthService();

let response_code=''; 
let hash;
let orderid;    
let amount;
let response;
let transactionid;
let avsresponse;
let cvvresponse;
let time;
let response_code_tab;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function WidgetCalendario2(props){
  const fecha= new Date()
  var fecha_anterior=new Date();
  fecha_anterior.setDate(fecha_anterior.getDate()-1)
  var fecha_superior=new Date();
  fecha_superior.setDate(fecha_superior.getDate()+1)

  const mes_a=fecha_anterior.getMonth()+1
  const dia_a=fecha_anterior.getDay()+1
  const mes=fecha.getMonth()+1
  const dia=fecha.getDay()+1
  const mes_d=fecha_superior.getMonth()+1
  const dia_d=fecha_superior.getDay()+1

  var mes_palabra=funciones.obtener_mes(mes);
  var dia_palabra=funciones.obtener_dia(dia);

  return(
  <Card className='WidgetCalendario-card'  style={{top:movil_ipad?'auto':props.noti===0?160:310}}>
  <CardHeader title={'Calendario'} className='WidgetCalendario-CardHeader' avatar={<Avatar style={{background: 'transparent'}}><Iconos fontSize='small' icono={'Time'} /></Avatar>} />
  <CardContent className='WidgetCalendario-CardContent'>
   <Grid container>
   <Grid xs={3} item>
   <Typography align='center' variant='h6' className='WidgetCalendario-Typographygris'>{funciones.obtener_dia(dia_a)}</Typography>
   <Typography align='center' variant='h5' className='WidgetCalendario-Typographygris'>{fecha_anterior.getDate()}</Typography>
   <Typography align='center' variant='h6' className='WidgetCalendario-Typographygris'>{funciones.obtener_mes(mes_a)}</Typography>
   </Grid>
   <Grid xs={6}  item>
   <Typography align='center' variant='h6' className='WidgetCalendario-Typographyfecha'>{dia_palabra}</Typography>
   <Typography align='center' variant='h4' className='WidgetCalendario-Typographyfecha actual'>{fecha.getDate()}</Typography>
   <Typography align='center' variant='h5' className='WidgetCalendario-Typographyfecha'>{mes_palabra}</Typography>
   </Grid>
   <Grid xs={3} item>
   <Typography align='center' variant='h6' className='WidgetCalendario-Typographygris'>{funciones.obtener_dia(dia_d)}</Typography>
   <Typography align='center' variant='h5' className='WidgetCalendario-Typographygris'>{fecha_superior.getDate()}</Typography>
   <Typography align='center' variant='h6' className='WidgetCalendario-Typographygris'>{funciones.obtener_mes(mes_d)}</Typography>
   </Grid>
   </Grid>
  </CardContent>
  <Button color='secondary' className='WidgetCalendario-Button' variant='outlined' onClick={()=>{window.open('https://calendar.google.com/calendar/u/0/r/month')}}>
     Ver Calendario
  </Button>
  </Card>
  );
}

/*                                                              VARIABLES                                                      */
var lista_tab=[];
var lista_tabpanel=[];
var valor;
var ip=globales.ip
var notificaciones_interval
var token_interval
var setTimeout_token

///GUARDA SI ES MOVIL O PC TRUE/FALSE
var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_ipad=/iPad/i.test(navigator.userAgent);


/*                           CLASES DE ESTILO                       */
var styles = theme =>({
})

/*                                     FUNCIONES                             */
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div" 
      role="tabpanel" 
      hidden={value !== index} 
      id={`full-width-tabpanel-${index}`} 
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <Box   mt={0} mr={0} ml={0} padding={0} margin={0} > {children} </Box>
    </Typography>
  );
}

///FUNCION DE COMPONENTE TAB
function LinkTab(props){
  return (
        <Tooltip title={props.label_completo} > 
            <Tab  onClick={(event) => {event.preventDefault();}} {...props}/>
        </Tooltip>
  );
}

function a11yProps(index) {
  return { id: `full-width-tab-${index}`,'aria-controls': `full-width-tabpanel-${index}`, };
}

/*                                      EXPORT                                 */
export default withStyles(styles)(
  class Principal extends React.Component {
  divRef = React.createRef();
  div_principalRef = React.createRef();
  div_paginaRef =React.createRef();
  
  constructor(props) {
  super(props);
   this.noti=0
   this.renderizo=0
   this.lista_tab=[];
   this.lista_tabpanel=[];
   this.audio = new Audio("/Multimedia/Audios/notificaciones.mp3");
   this.estado_refresh=Auth.getProfile().estado_refresh
   this.estado_refresh_widgets= Auth.getProfile().estado_refresh_widgets
   this.interval_widget=Auth.getProfile().interval_widget

   if(localStorage.getItem('switch')===null)
   localStorage.setItem('switch',true)

   if(localStorage.getItem('notificaciones')===null)
   localStorage.setItem('notificaciones','[]')
   

    this.state = {
       switch_publi: localStorage.getItem('switch')==='false'?false:true,
       open_imagen: false,
       open_mensaje_token: false,
       image: '',
       likes:       [],
       redirect:    false,
       info:        Auth.getProfile(),
       notificaciones: JSON.parse(localStorage.getItem('notificaciones')),
       Body:        [],
       Bodytab:     [],
       estado_menu: true,
       app:         [],
       i:           this.lista_tab.length,
       value:       this.lista_tab.length-1<0?0:this.lista_tab.length-1,
       isLoggin :   undefined,
       open:        false,
       open_modal:  false,
       carga:       false,
       hiddenLinear: true,
       hiddenCircular: true,
       open_filtro:  false,
       filtro: 'all',
       mensaje:'',
       bloqueo: false,
       paginas_bloqueo: '',
       open_bloqueo: false,
       todos_bloqueos: [],
       cargando: true,
       titulo_mensaje: 'Mensaje',
       alineacion_mensaje: 'center',
       max_width_mensaje:'xs',
       background_mensaje:'white',
       background_titulo_mensaje:colores.azul,
       color_titulo_mensaje:'white',
       color_mesaje: 'black',
       open_manual: false,
       pdf: '',
       permisos_paginas: {},
       permisos_usuario: [],
       open_dialog_pago:  false,
       msg_pago:''
    };
  

  };//FIN CONSTRUCTOR

cargar(p){
    if(this.lista_tab.filter(busqueda2 =>busqueda2.pagina===p.pagina?true:false).length===0 ){
      //if(this.state.info.plataforma===1)
     // {
        const _this=this;
           lista_tab.push({pagina:p.pagina, icono:p.icono, nombre:p.nombre, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual});
           lista_tabpanel.push({pagina: p.pagina, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual});
          _this.lista_tab= lista_tab;
          var arr=[]
          
          if((p.ultimo-1)===p.index && (localStorage.getItem('Actual')===null || localStorage.getItem('Actual')===(p.ultimo-1)))
          {
            for (let step = 0; step < p.ultimo-1; step++) {
              arr.push(['0'])
            }
            arr.push({pagina: p.pagina, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual})
            _this.lista_tabpanel=arr
            
          }
          else if(localStorage.getItem('Actual')!==null)
          {
            if(localStorage.getItem('Actual') === p.index.toString())
            {
              _this.lista_tabpanel.push({pagina: p.pagina, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual})
            }
            else{
              _this.lista_tabpanel.push(['0'])
            }
          }
         
         _this.setState({Bodytab: lista_tab
          , i: _this.lista_tab.length
          , Body: arr.length===0?_this.lista_tabpanel:arr
          , value: localStorage.getItem('Actual')===null?_this.lista_tab.length-1<0?0:_this.lista_tab.length-1 : parseInt(localStorage.getItem('Actual'))>_this.lista_tab.length-1?0:parseInt(localStorage.getItem('Actual'))
        })
      
        if(p.ultimo===lista_tab.length)
        {
          var actual=[]; 
          actual= localStorage.getItem('Tabs_user')===null? []:JSON.parse(localStorage.getItem('Tabs_user'))
          if(actual.filter(busqueda2 =>busqueda2.usuario.match(_this.state.info.user)).length>0){
            actual.map((item,index) =>{
              if (item.usuario===_this.state.info.user)
              {
                item.tabs=lista_tab;
              }
              return '';
            })
          }
          else
          {
            actual.push({usuario:this.state.info.user, tabs:this.lista_tab})
          }
            localStorage.setItem('Tabs_user',JSON.stringify(actual))
        }
    }
  }

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  confirma_nom(l){
    if(this.state.info.plataforma!==1 && !movil_pequeño)
    {
      return l
    }
    else
    {
      if(l.length<13)
        return l
      else
        return l.substring(0,13)+'...'
    }
  }

handleClick_1 =  event => {   
    let _this=this;
    Auth.logout()
    _this.setState({redirect:true, usuario: ''})
    /*
        (async function() {
          await Promise.resolve (Auth.logout())
          let x = await Auth.loggedIn();
          if(!x)  {
           _this.setState({redirect:true, usuario: ''})
         }  
        })();*/
};

click_filtro_noti = event => {
  this.setState({open_filtro: true})
}

handleChange_filtro = event => {
  this.setState({filtro: event.target.value})
};

///TOMA VALOR DEL TAB SELECCIONADO
handleChange=(event, newValue)=> {

  if(valor!==undefined){
    var arr_close=[]
    var valor_actual;

    if(this.state.value===valor)
    {
      if(valor===this.state.i-1)
      {
        valor_actual=valor-1<0?0:valor-1
      }else
      if(valor>=0&&valor<this.state.i-1)
      {
        valor_actual=valor
      }
      else{valor_actual=0; localStorage.removeItem('Actual')} 
    }else{
      valor_actual=valor>this.state.value?this.state.value:this.state.value-1<0?0:this.state.value-1
    } 
    lista_tabpanel.forEach((value,index) => {
      if(value.pagina===this.lista_tabpanel[index].pagina)
      { arr_close.push(value)//arr.push(this.lista_tabpanel[index]) 
      }
      else if(index===0 && index===valor_actual)
      arr_close.push(value)
      else if (index===lista_tabpanel.length-1 && index===valor_actual){
        arr_close.push(value)
      }
      else{arr_close.push(['0'])}
    })

    this.lista_tabpanel=arr_close

    if(this.state.i-1===0){
      localStorage.removeItem('Actual')
    }
    else{
      localStorage.setItem('Actual',valor_actual)
    }
    this.setState({value: valor_actual,i: this.state.info.plataforma===1?this.state.i-1<0?0:this.state.i-1:0
      , Bodytab: this.lista_tab,Body: this.lista_tabpanel
    }); 
    valor=undefined
  } ///// final if valor!==undefined
  else
  {
    var arr=[]
    lista_tabpanel.forEach((value,index) => {
        if(newValue===index)
        {
          if(this.lista_tabpanel[index]===undefined){arr.push(value)}
          else{arr[index]=value}
        }else
        {
          if(this.lista_tabpanel[index]===undefined || this.lista_tabpanel[index][0]==='0')
          {
           arr.push(['0'])
          }
          else{
            
            arr.push(value)
          }
        }
    });
      this.lista_tabpanel=arr
      
      if(this.state.value!==newValue){
        this.setState({value: newValue, Body: this.lista_tabpanel}); 
        localStorage.setItem('Actual',newValue)
      }
  }
  event.preventDefault();
}


///QUITA PAGINA DESDE BARRA TABPANEL
quitartab=(event)=>{

  lista_tab.splice(this.state.value,1)
  lista_tabpanel.splice(this.state.value,1)

  this.lista_tab=lista_tab;
  this.lista_tabpanel.splice(this.state.value,1)
  var valor_actual;

  if(this.state.value===this.state.i-1)
  {
    valor_actual=this.state.value-1
  }else if(this.state.value>=0&&this.state.value<this.state.i-1)
  {
    valor_actual=this.state.value
  }else{valor_actual=0; localStorage.removeItem('Actual')}
 
  var arr=[];
  lista_tabpanel.forEach((value,index) => {
    if(value.pagina===this.lista_tabpanel[index].pagina)
    { arr.push(value)
    }
    else if(index===0 && index===valor_actual)
      arr.push(value)
    else if (index===lista_tabpanel.length-1 && index===valor_actual){
      arr.push(value)
    }
    else{arr.push(['0'])}
  })
  this.lista_tabpanel=arr

  this.setState({value: valor_actual
    ,Bodytab: this.lista_tab
    , Body: this.lista_tabpanel.length===1?lista_tabpanel:this.lista_tabpanel
    ,i: this.state.info.plataforma===1?this.state.i-1:0})
  
  //if(this.state.info.plataforma===1)
  //{
    var arrtab=[];
    arrtab= localStorage.getItem('Tabs_user')===null? []:JSON.parse(localStorage.getItem('Tabs_user'))
    if(arrtab.filter(busqueda2 =>busqueda2.usuario.match(this.state.info.user)).length>0){
      arrtab.map((item,index) =>{
        if (item.usuario===this.state.info.user)
        {
          item.tabs=this.lista_tab;
        }
        return '';
      })
    }
    if(this.lista_tab.length===0 || this.state.i-1===0)
    {
      localStorage.removeItem('Actual')
    }
    else{
      localStorage.setItem('Actual',valor_actual)
    }
    localStorage.setItem('Tabs_user',JSON.stringify(arrtab))
  //}
}

///QUITA PAGINA DESDE TABS
quitartab_close=(index)=>event=>{

  valor=index
  lista_tab.splice(index,1)
  lista_tabpanel.splice(index,1)
  
  this.lista_tab=lista_tab;
  this.lista_tabpanel.splice(index,1);

  //if(this.state.info.plataforma===1)
  //{
    var arr=[];
        arr= localStorage.getItem('Tabs_user')===null? []:JSON.parse(localStorage.getItem('Tabs_user'))
        if(arr.filter(busqueda2 =>busqueda2.usuario.match(this.state.info.user)).length>0){
          arr.map((item,index) =>{
            if (item.usuario===this.state.info.user)
            {
              item.tabs=this.lista_tab;
            }
            return '';
          })
        }
      
    localStorage.setItem('Tabs_user',JSON.stringify(arr))
  //}
}

actualizarbarra=(hidden)=>{
  if(hidden){
    this.setState({hiddenLinear: true})
  }
  else{
    this.setState({hiddenLinear: false})
  }
}
actualizarcircular=(hidden)=>{
  if(hidden){
    this.setState({hiddenCircular: true})
  }
  else{
    this.setState({hiddenCircular: false})
  }
}

///AGREGA PAGINA PARA TABS
cargarstate = (p)=> event =>{
  const _this=this
  this.Obtiene_paginas_bloqueo()
  var bloquear=false;

  for (let index = 0; index < this.state.todos_bloqueos.length; index++) {
    var sp=this.state.todos_bloqueos[index].PAGINAS.split(',');
    for (let indexI = 0; indexI < sp.length; indexI++) {
      if(sp[indexI]===p.pagina){
        if(this.state.todos_bloqueos[index].BLOQUEAR===true)
        bloquear=true;
        this.setState({open_bloqueo: true, mensaje: this.state.todos_bloqueos[index].MENSAJE
          ,titulo_mensaje:this.state.todos_bloqueos[index].TITULO===''?'Mensaje':this.state.todos_bloqueos[index].TITULO
          ,alineacion_mensaje: this.state.todos_bloqueos[index].ALINEACION
          ,max_width_mensaje: this.state.todos_bloqueos[index].MAX_WIDTH
          ,background_mensaje: this.state.todos_bloqueos[index].DEFAULT_BM?'white':this.state.todos_bloqueos[index].BACKGROUND_MENSAJE
          ,background_titulo_mensaje: this.state.todos_bloqueos[index].DEFAULT_BT?colores.azul:this.state.todos_bloqueos[index].BACKGROUND_TITULO
          ,color_titulo_mensaje: this.state.todos_bloqueos[index].DEFAULT_CT?'white':this.state.todos_bloqueos[index].COLOR_TITULO
          ,color_mesaje: this.state.todos_bloqueos[index].DEFAULT_CM?'black':this.state.todos_bloqueos[index].COLOR_MENSAJE
        })
        index=this.state.todos_bloqueos.length
        break;
      }
    }
  }
    if((this.lista_tab.filter(busqueda2 =>busqueda2.nombre===p.nombre?true:false).length===0 && ((this.state.bloqueo===false) || (this.state.bloqueo===true && bloquear===false)))){
      if(_this.state.info.plataforma===1)
      {
        if(_this.state.Bodytab.length < (movil?/iPad/i.test(navigator.userAgent)?8:6:10))
        {
          lista_tab.push({pagina:p.pagina, icono:p.icono, nombre:p.nombre, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual});
          lista_tabpanel.push( {pagina: p.pagina, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual} );
          _this.lista_tab=lista_tab;
          var arradd=this.lista_tabpanel;
          arradd.push({pagina:p.pagina, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual})
          this.lista_tabpanel=arradd
          _this.setState({value: this.lista_tabpanel.length-1,Body: this.lista_tabpanel, Bodytab: this.lista_tab, i: _this.state.i+1})

          localStorage.setItem('Actual',this.lista_tabpanel.length-1)

          var arr=[]; 
          arr= localStorage.getItem('Tabs_user')===null? []:JSON.parse(localStorage.getItem('Tabs_user'))
          if(arr.filter(busqueda2 =>busqueda2.usuario.match(_this.state.info.user)).length>0){
            arr.map((item,index) =>{
              if (item.usuario===_this.state.info.user)
              {
                item.tabs=lista_tab;
              }
              return '';
            })
          }
          else
          {
            arr.push({usuario:this.state.info.user, tabs:this.lista_tab})
          }
         
          localStorage.setItem('estado_menu', false)
          localStorage.setItem('Tabs_user',JSON.stringify(arr))
        }
        else{
          funciones.showToast('i', 'Solo se permiten '+(movil?movil_ipad?8:6:10)+' ventanas.','Límite de ventanas')
          
        }
      }
      else //ES ALUMNO O CATEDRATICO
      {
        this.lista_tab.splice(0,1);
        this.lista_tabpanel.splice(0,1);
        //_this.setState({value: _this.state.i,Body: this.lista_tabpanel, Bodytab: this.lista_tab, i: _this.state.i, estado: false })
        
        this.lista_tab.push({pagina:p.pagina, icono:p.icono, nombre:p.nombre, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual});
        this.lista_tabpanel.push({pagina: p.pagina, descripcion:p.descripcion, reporte:p.reporte, manual:p.manual});
        _this.setState({value: this.lista_tab.length-1, estado_menu: false,Body: this.lista_tabpanel, Bodytab: this.lista_tab, i: _this.state.i+1, estado: false })
  
        localStorage.setItem('Actual',this.lista_tab.length-1)
        var arrr=[]; 
          arrr= localStorage.getItem('Tabs_user')===null? []:JSON.parse(localStorage.getItem('Tabs_user'))
          
          if(arrr.filter(busqueda2 =>busqueda2.usuario.match(_this.state.info.user)).length>0){
            arrr.map((item,index) =>{
              if (item.usuario===_this.state.info.user)
              {
                item.tabs=_this.lista_tab;
              }
              return '';
            })
          }
          else
          {
            arrr.push({usuario:this.state.info.user, tabs:this.lista_tab})
          }
          localStorage.setItem('Tabs_user',JSON.stringify(arrr))
          localStorage.setItem('estado_menu', false)
      }
    }
}

consulta_permisos_pagina=()=>{
  this.setState({cargando: true,open: true},()=>{
    try{
      Request.post(`${ip}/obtener_permisos_paginas`)
      .set({'authorization': 'Bearer ' + Auth.getToken() })
      .set('Content-Type', 'application/json')
      .send({PLATAFORMA:  Auth.getProfile().plataforma,cuenta_alumno:  Auth.getProfile().user.toString()})
      .retry(0)
      .timeout({ response: 20000, deadline: 60000, }) 
      .end((err, res) => {
    
      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        { 
          this.setState({ isLoggin: false})
          return;  
        }    
      }
      var array={}
  
      if(res!==undefined)
      {
      const tmp = JSON.parse(res.text);

      if(tmp.length>0)
      {
        tmp.forEach(
          function getCheck(text, index) {
              array[text.INSTANCIA]= [text.ID_PERMISO,text.LECTURA,text.ESCRITURA,text.IMPRESION]
          }
        )

        this.setState({permisos_paginas: array,cargando:false,open: false,permisos_usuario:tmp})
      }
    }
    else
    {
      funciones.showToast('e','Problemas de conexión.');
      this.setState({permisos_paginas: {},cargando:false,open: false,permisos_usuario:[]})
    }
  })
  }
  catch(ex){
    this.setState({permisos_paginas: {},cargando:false,open: false,permisos_usuario:[]})
  }
  })
}

componentDidMount(){

  
//**************************************  PARÁMETROS CREDOMATIC  **************************************************/    
let values = queryString.parse(this.props.location.search)
 
if (Object.keys(values).length !== 0)
  {

      if(values.response_code!==undefined && values.hash!==undefined          && values.orderid!==undefined     &&  values.amount!==undefined     &&
         values.response!==undefined      && values.transactionid!==undefined && values.avsresponse!==undefined && values.cvvresponse!==undefined && values.time!==undefined
        ) 
      { 

        response_code = values.response_code; 
        hash          = values.hash;
        orderid       = values.orderid;    
        amount        = values.amount;
        response      = values.response;
        transactionid = values.transactionid;
        avsresponse   = values.avsresponse;
        cvvresponse   = values.cvvresponse;
        time          = values.time;  
        response_code_tab = values.response_code==='100'?true:false;

        this.HashPaymentButtonValidation(values.orderid);         
      } 
   
}
else  if (localStorage.getItem("HashPBV") !== null)
  {     
    localStorage.removeItem("HashPBV");
  }


//************************************** FIN PARÁMETROS CREDOMATIC  **************************************************/

  let _this = this;
  _this.consulta_permisos_pagina();
  Auth.loggedIn().then(function(b){   
      _this.setState({ isLoggin: b });
      if(b){
        _this.Notificacion_derecha();

        _this.validacion_token();

        token_interval=setInterval(_this.validacion_token,Auth.getProfile().mseg_interval_valida_token)
        var local = JSON.parse(localStorage.getItem('Tabs_user'));
        var lista_tab_did =[];
        
        //if(Auth.getProfile().plataforma===2)
        try{
          Request.post(`${ip}/obtener_pendientes_alumno`)
          .set({'authorization': 'Bearer ' + Auth.getToken() })
          .set('Content-Type', 'application/json')
          .send({cuenta_alumno:  Auth.getProfile().user.toString()})
          .retry(0)
          .timeout({ response: 30000, deadline: 60000, }) 
          .end((err, res2) => {
         
          if (err) { 
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            { 
              return;  
            }    
          }

          var tmp3
          if(res2!==undefined)
            tmp3 = JSON.parse(res2.text);

          if(tmp3.length>0)
          {
            usuario.like=JSON.parse(tmp3[0].LIKES);
            pendientes_alumno.matricula=tmp3[0].MATRICULA;
            pendientes_alumno.cuotas=tmp3[0].CUOTAS;
            pendientes_alumno.toda_factura=tmp3[0].TODA_FACTURA;
            /*var arr=[]
            usuario.like.forEach(element => {
              arr.push(element.ID)
            });*/
            _this.setState((state)=>({state:state}))
          }
        })
        }
        catch(ex){}

      if(local!==null && (local.filter(busqueda2 =>busqueda2.usuario=== Auth.getProfile().user?busqueda2.tabs.length>0?true:false:false).length>0))
      {
        lista_tabpanel=[];
        lista_tab=[];
        ///////////////////////////////
        Request.get(`${ip}/Obtener_paginas_bloqueo/${ Auth.getProfile().user}/${parseInt( Auth.getProfile().plataforma)}`)
        .set({'authorization': 'Bearer ' + Auth.getToken() })
        .retry(0)
        .timeout({ response: 30000, deadline: 50000, })
        .end((err, res2)=>{
      if (err) { 
        
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
          //window.location.reload();
          this.setState({isLoggin:false})
          return;
        }
        (async function() {
          funciones.showToast('e', 'Error de conexión')
        })();//FIN FUNCION ASYNC
        return;
      }
        const tmp3 = JSON.parse(res2.text);
        if(tmp3.length>0)
        {
        var todos=[];
        var paginas=[];
        for (let index = 0; index < tmp3.length; index++) {
            todos.push(tmp3[index])
            Array.prototype.push.apply(paginas,tmp3[index].PAGINAS.split(','))
          
        if(index===tmp3.length-1){
          
        _this.setState({todos_bloqueos:todos, bloqueo: todos.length>0?true:false, paginas_bloqueo: paginas})
        local.map((item,index) =>{
          if (item.usuario=== Auth.getProfile().user)
          {

            //lista_tab_did=item.tabs
            Array.prototype.push.apply(lista_tab_did,item.tabs)
            
            item.tabs.map((item2,index) =>{
     
                if(paginas.filter(busqueda2 =>busqueda2===item2.pagina?true:false).length>0)
                {
                  var arr=[]; 
                  arr= localStorage.getItem('Tabs_user')===null? []:JSON.parse(localStorage.getItem('Tabs_user'))
                  if(arr.filter(busqueda2 =>busqueda2.usuario.match(_this.state.info.user)).length>0){
                    arr.map((item,indexarr) =>{
                      if (item.usuario===_this.state.info.user)
                      {
                        lista_tab_did.splice(index,1)
                        item.tabs=lista_tab_did;
                        var valor_actual=0;
                        var actual=parseInt(localStorage.getItem('Actual'))
                        if(actual===item.tabs.length)
                        {
                          valor_actual=actual-1
                        }else if(actual>=0&&actual<item.tabs.length-1)
                        {
                          valor_actual=actual
                        }else{valor_actual=0; localStorage.removeItem('Actual')}
                        localStorage.setItem('Actual',valor_actual )
                      }
                      return '';
                    })
                  }
                  else
                  {
                    arr.push({usuario:_this.state.info.user, tabs:_this.lista_tab})
                  }
                  localStorage.setItem('Tabs_user',JSON.stringify(arr)) 
                  }
              return '';
            })
            lista_tab_did.map((item2,index) =>{
              _this.cargar({reporte:item2.reporte,pagina: item2.pagina,icono: item2.icono,nombre: item2.nombre, descripcion: item2.descripcion, ultimo: item.tabs.length, index: index, manual: item2.manual})
              return '';
            })  
          }
          return '';
          })
          }
          }
        }
        else
        {
          local.map((item,index) =>{
            if (item.usuario=== Auth.getProfile().user)
            {
              item.tabs.map((item2,index) =>{
                _this.cargar({reporte:item2.reporte,pagina: item2.pagina,icono: item2.icono,nombre: item2.nombre, descripcion: item2.descripcion, ultimo: item.tabs.length, index: index, manual: item2.manual})
                return '';
              })
            }
            return '';
          })
        }
        })
    //////////////////////
      }else{
        _this.Obtiene_paginas_bloqueo();
      }  
    }
    })
    if(Auth.getProfile().estado_refresh===1)
    {
      notificaciones_interval=setInterval(this.Notificacion_derecha, Auth.getProfile().interval_noti);
    }
    
}

handlePrintClick = (TRANSACTIONID)=>()=>{

  
  this.setState({ textbackdrop: "Procesando...",openBackDrop: true }, ()=>{
   
  new Request
  .get(`${globales.ip}/pagolinea/recibo/${Auth.getProfile().user.toString()}/${TRANSACTIONID}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {         
          window.location.reload();
          return;             
        }
  
        this.setState({ openBackDrop: false }, ()=>{ 
         funciones.showToast('e', 'No hay conexión');
        });
    
        return;
     }
        
     const rows = JSON.parse(res.text);
  
     let monto = 0;
     rows.map((item)=>{
       monto += item.MONTO_TOTAL; 
       return item;
     });
     
     funciones.crearReciboPdf(this.state.orderid, 
                              funciones.getTime(rows[0].FECHA_PAGO), 
                              funciones.getTime(new Date(new Date()+" UTC").toISOString().slice(0, 10) + " 00:00:00", 0),
                              rows[0].REFERENCIA1,
                              rows[0].CUENTA_ALUMNO,
                              rows[0].NOMBRE_COMPLETO,
                              rows[0].DESCRIPCION_PLAN, 
                              rows,
                              rows[0].Simbolo + funciones.formatCurrency(monto),
                              rows[0].Simbolo + funciones.formatCurrency(monto), 
                              rows[0].Simbolo + "0.00", 
                              'Pago en línea',
                              movil, 
                              ()=>{});              
     
  });
  
  });
  
  }

gestionPagoLinea(CUENTA_ALUMNO,RESPONSE_CODE,CREDOMATIC_HASH,ORDERID,AMOUNT,RESPONSE,TRANSACTIONID,AVSRESPONSE,CVVRESPONSE,TIME)
{
  
new Request
  .post(`${globales.ip}/pagolinea/pago/`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .send({ 
		CUENTA_ALUMNO:CUENTA_ALUMNO,
		RESPONSE_CODE:RESPONSE_CODE,
    CREDOMATIC_HASH:CREDOMATIC_HASH,
    ORDERID:ORDERID,
    AMOUNT:AMOUNT,
    RESPONSE:RESPONSE,
    TRANSACTIONID:TRANSACTIONID,
    AVSRESPONSE:AVSRESPONSE,
    CVVRESPONSE:CVVRESPONSE,
    TIME:TIME

   })
  .retry(0)
  .timeout({ response: 60000, deadline: 60000, }) 
  .end((err, res) => {
    
      if (err) { 
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
        
        window.location.reload();
        return;
          
       }
 
       funciones.showToast('e', 'Error de conexión'); 
 
        return;
 
      }
      
       const result = JSON.parse(res.text);
    
      if (result.length > 0) 
      {    
          
        const buttonPrint=
      (
        <React.Fragment>
           <Button 
                 variant="contained"
                 color='primary'
                 size="small"
                 onClick={this.handlePrintClick(TRANSACTIONID)}
                startIcon={<Iconos fontSize='large' icono={'Print'} />}
                style={{ display: true,   textTransform:'none',  /*marginRight:20*/ }} >             
                Recibo
        </Button> 

       
        </React.Fragment>

      )
      const boton_cerrar_modal_pago =[
        {icono: 'Close', nombre: 'Cerrar' ,onclick: this.cerrarmodal_pago(), display:'auto'} ]
        
      const msg=(
            <React.Fragment>
             
    <div style={{ display:'flex', justifyContent: 'center',alignItems: 'center',height:'100%',textAlign:'center'}}>
          <div style={{overflow:"hidden", textAlign:'center',display:'block', verticalAlign: 'middle' }}> 
         
         <div style={{display:'flex',justifyContent: 'center',alignItems: 'center',padding:'10px'}}>
          <div > {RESPONSE_CODE==='100' && result[0].RESP==='OK'? <Checkmark size='32px' color={colores.azul}  />:''}  </div>
          <div style={{verticalAlign:'center',textAlign:'center',marginLeft:'10px'}}> 
          <Typography variant="h6"  color={result[0].RESP==='OK'?'primary':'error'} > 
              
                {result[0].MSG}
                          
           </Typography>
          </div>  
          </div>

          <div style={{float: 'left',width:'100%', textAlign:'center',padding:'10px'}}  >
   
          {RESPONSE_CODE==='100' && result[0].RESP==='OK'? buttonPrint:''}
          <div>
            <BarraBotones align='center' botones={boton_cerrar_modal_pago}/>
          </div>

</div>    
</div>    
</div>
</React.Fragment>
)
        this.setState({open_dialog_pago:true, msg_pago:msg});
      }
  }); 
  return ''; 
}

HashPaymentButtonValidation = (orderid) =>{
  
  if(localStorage.getItem("HashPBV")!==null || 1===1)
    {
      Request
            .post(`${globales.ip}/pagolinea/HashPaymentButtonValidation`) 
            .send({    
              cuenta_alumno: Auth.getProfile().user.toString(),
              orderid:       orderid,
              HashPBV:       localStorage.getItem("HashPBV"),            
            })       
            .retry(1)
            .timeout({ response: 60000, deadline: 60000, })
            .end((err, res) => {
                    
                if (err) {
            
                  if (err.toString().substr(0,16) === 'Error: Forbidden')
                  {                  
                    return;                     
                  }
            
                  (async function() {
                  
                  })();//FIN FUNCION ASYNC
              
                  return;
                }
                  
                const datos  = JSON.parse(res.text);
                      
                if (datos  !== undefined) {  
                                                 
                  if(datos.isValid)
                    {
                      localStorage.removeItem("HashPBV");
                      this.registroPrevioPagos(orderid,3);
                      this.gestionPagoLinea(Auth.getProfile().user.toString(),response_code,hash,orderid,amount,response,transactionid,avsresponse,cvvresponse,time)                  
                    }
                    
                }
                                           
              else //SI NO HAY REGISTROS
              {             
              }                             
              });
    }
    else{ 
      this.limpiarParametrosURL();
    }
  }

registroPrevioPagos = (ID_FACTURA,TIPO) =>{ 
      Request
             .post(`${globales.ip}/pagolinea/registroPrevioPagos`) 
             .send({    
              CUENTA_ALUMNO :Auth.getProfile().user,
              ID_FACTURA    :ID_FACTURA,
              TIPO          :TIPO
             })       
             .retry(1)
             .timeout({ response: 60000, deadline: 60000, })
             .end((err, res) => {
                     
                if (err) {
             
                   if (err.toString().substr(0,16) === 'Error: Forbidden')
                   {                  
                     return;                     
                   }           
                   (async function() {
                  
                   })();//FIN FUNCION ASYNC            
                   return;
                }
                   
                const datos  = JSON.parse(res.text);                     
                if (datos  !== undefined) {                   
                  if(datos.RESP==='OK' && datos.RESULT>=1){                  
                    localStorage.removeItem("HashPBV");
                    this.setState({open_dialog_pago:true,msgbloqueoPago:datos.MSG,bloqueoPago:true})  
                  }else{ 
                    this.setState({open_dialog_pago:false})                
                  }                       
                }                         
               else //SI NO HAY REGISTROS
               {               
               }                                     
              });   
      }

Obtiene_paginas_bloqueo(){
    var _this=this
    Request.get(`${ip}/Obtener_paginas_bloqueo/${ Auth.getProfile().user}/${ Auth.getProfile().plataforma}`)
    .retry(0)
    .timeout({ response: 30000, deadline: 60000, })
    .end((err, res2)=>{
      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
          window.location.reload();
          return;
        }
        return;
      }
      const tmp3 = JSON.parse(res2.text);
      if(tmp3.length>0)
      {
      var todos=[];
      var paginas=[];
      for (let index = 0; index < tmp3.length; index++) {
          todos.push(tmp3[index])
          Array.prototype.push.apply(paginas,tmp3[index].PAGINAS.split(','))
        
      if(index===tmp3.length-1)  
      _this.setState({todos_bloqueos:todos, bloqueo: todos.length>0?true:false, paginas_bloqueo: paginas})
      }
        }
    })
}

Limpiar_Principal=()=>{
  var _this=this
  _this.estado_refresh=0
  _this.noti=0
  _this.lista_tab=[]
  _this.lista_tabpanel=[]
  lista_tab=[];
  lista_tabpanel=[];
  localStorage.removeItem('notificaciones');
  clearInterval(notificaciones_interval)
  clearInterval(token_interval)
}

Notificacion_derecha=()=>{
  var _this=this

    if(_this.estado_refresh===1 && _this.renderizo===1)
    {
        try{
          Request.post(`${ip}/obtener_notificaciones_principal`)
          .set({'authorization': 'Bearer ' + Auth.getToken() })
          .set('Content-Type', 'application/json')
          .send({cuenta_alumno:  Auth.getProfile().user.toString(),ROL: Auth.getProfile().rol,PLATAFORMA:  Auth.getProfile().plataforma,matricula: pendientes_alumno.matricula,cuotas: pendientes_alumno.cuotas,toda_factura: pendientes_alumno.toda_factura})
          .retry(0)
          .timeout({ response: 30000, deadline: 60000, }) 
          .end((err, res2) => {
         
          if (err) { 
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            { 
              _this.setState({isLoggin: false})
              return;  
            }    
          }

      var tmp3
      if(res2!==undefined)
        tmp3 = JSON.parse(res2.text);
      else
        tmp3 =_this.state.notificaciones

      if(tmp3.length>0)
      {
        var original=_this.noti
        _this.noti=0
        tmp3.map((text,index,array)=>(
          text.LADO==='D'?_this.noti++:''
        ));
        
        if(original!==_this.noti && original<_this.noti && _this.renderizo===1)
        {
          _this.audio.play();
          funciones.showToast('i','Notificación Nueva');
        }

        if(JSON.stringify(_this.state.notificaciones)!==JSON.stringify(tmp3)){
          localStorage.setItem('notificaciones',JSON.stringify(tmp3));
          _this.setState({notificaciones: tmp3});
        }
        else{
          _this.renderizo= 1
        }
      }
      else{
        if(JSON.stringify(_this.state.notificaciones)!==JSON.stringify(tmp3)){
          _this.setState({notificaciones: []})
          localStorage.setItem('notificaciones','[]');
          _this.noti=0
        }
      }
    })
  }
  catch(ex){}
  }
  else{
    _this.noti=0
    if(_this.state.notificaciones!==null && _this.state.notificaciones!==undefined){
      _this.state.notificaciones.map((text,index,array)=>(text.LADO==='D'?_this.noti++:''))
      if(localStorage.getItem('switch')==='false' && _this.renderizo===0 && Auth.getProfile().plataforma===1){
        var f=false;
        _this.state.notificaciones.forEach(
          function getCheck(text, index) {
          if(text.LADO==='I' && !f && _this.state.i===0){
            funciones.showToast('i','Tiene Publicaciones Ocultas.')
            f=true;
          }
        })
      }
      _this.setState((state)=>{return state})
      _this.renderizo= 1
    }
  }
}

abrirmodal=()=>event=>{
  event.preventDefault();
  if(this.noti!==0 && this.state.Body.length>0)
  this.setState({open_modal: true, open: false})
}

abrirmodal_principal=()=>event=>{
  event.preventDefault();
  if(this.noti!==0 && this.state.Body.length===0)
  this.setState({open_modal: true, open: false})
}

clicklike= (ID)=>event=>{
  var arr=this.state.likes;
  //arr.push(ID) //controla solo dar una vez por sesión
  try{
    var notificaciones = this.state.notificaciones//JSON.parse(localStorage.getItem('notificaciones'));
    new Request.post(`${globales.ip}/ID_ME_GUSTA`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({ID_NOTIFICACIONES_IZQUIERDA_PRINCIPAL:parseInt(ID),cuenta_alumno: Auth.getProfile().user,ID_PLATAFORMA:parseInt( Auth.getProfile().plataforma),TIPO: 1})
    .retry(0)
    .timeout({ response: 20000, deadline: 60000, }) 
    .end((err, res) => {

      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        { 
          window.location.reload();
          return;  
        }       
          funciones.showToast('e', 'Error de conexión'); 
      }

   /* for (var i = 0; i < notificaciones.length; i++) {
      if(notificaciones[i].LADO==='I')
      if (notificaciones[i].ID === parseInt(ID)) {
        notificaciones[i].LIKES = notificaciones[i].LIKES===1?null:1
        break;
      }
    }*/

    const rows = JSON.parse(res.text);
    if(rows[0].RESP==='OK')
    {
      if(usuario.like.find(element=>element.ID===parseInt(ID)))
      for (var i = 0; i < usuario.like.length; i++) {
        if (usuario.like[i].ID === parseInt(ID)) {
          usuario.like[i].VALUE = usuario.like[i].VALUE===1?null:1
          break;
        }
      }
      else
      {
        usuario.like.push({ID:parseInt(ID),VALUE:1})
      }
    }
    else{
      funciones.showToast('w',rows[0].RESP)
    }
    //localStorage.setItem('notificaciones',JSON.stringify(notificaciones))
    this.setState({likes: arr,notificaciones: notificaciones})
  });   
}
catch(ex){
    console.log(ex)
}
} 

clicknotlike= (ID)=>event=>{
  var arr=this.state.likes;
  //arr.push(ID) //controla solo dar una vez por sesión
  try{
    var notificaciones = this.state.notificaciones//JSON.parse(localStorage.getItem('notificaciones'));
    new Request.post(`${globales.ip}/ID_ME_GUSTA`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({ID_NOTIFICACIONES_IZQUIERDA_PRINCIPAL:parseInt(ID),cuenta_alumno: Auth.getProfile().user,ID_PLATAFORMA:parseInt( Auth.getProfile().plataforma),TIPO: 0
    ,USUARIO:  Auth.getProfile().user,})
    .retry(0)
    .timeout({ response: 20000, deadline: 60000, }) 
    .end((err, res) => {

      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        { 
          window.location.reload();
          return;  
        }       
       
          funciones.showToast('e', 'Problemas de conexión'); 
      }

   /* for (var i = 0; i < notificaciones.length; i++) {
      if(notificaciones[i].LADO==='I')
      if (notificaciones[i].ID === parseInt(ID)) {
        notificaciones[i].LIKES = notificaciones[i].LIKES===0?null:0
        break;
      }
    }*/

    if(usuario.like.find(element=>element.ID===parseInt(ID)))
    for (var i = 0; i < usuario.like.length; i++) {
      if (usuario.like[i].ID === parseInt(ID)) {
        usuario.like[i].VALUE = usuario.like[i].VALUE===0?null:0
        break;
      }
    }
    else
    {
      usuario.like.push({ID:parseInt(ID),VALUE:0})
    }

    //localStorage.setItem('notificaciones',JSON.stringify(notificaciones))
    this.setState({likes: arr,notificaciones: notificaciones})
  });   
}
catch(ex){
  console.log(ex)
}
} 

cerrarmodal=()=>event=>{
  this.setState({open_modal: false, open: false, open_filtro: false})
  event.preventDefault();
}
cerrarmodal_bloqueo=()=>event=>{
  this.setState({open_bloqueo: false})
}

cerrarmodal_pago=()=>event=>{
  this.setState({open_dialog_pago: false})
    this.limpiarParametrosURL();
       
    if(response_code_tab)
      {       
        this.quitartab();       
      };
}

clearResponseCode=()=>{
   response_code='';
}

limpiarParametrosURL=(event)=>{
  var myNewURL = "Principal";//the new URL
  window.history.pushState("object or string", "Title", "/" + myNewURL );
}

AbrirImagen=(url)=>event=>{
  this.setState({open_imagen: true,image: url})
}

cerrar_imagen=()=>event=>{
  this.setState({open_imagen: false,image: ''})
}

validacion_token=()=>{
  var tiempo =(new Date(Auth.getProfile().exp* 1000).getTime()-new Date().getTime())/1000
  if(tiempo<Auth.getProfile().seg_confirmar_token && !this.state.open_mensaje_token){
    this.setState({open_mensaje_token: true},()=>{
      this.audio.play();
    })
    
    setTimeout_token=setTimeout(() => {
      clearInterval(token_interval)
      clearInterval(notificaciones_interval)
      this.Limpiar_Principal()
      this.setState({open_mensaje_token: false,isLoggin:false})
    }
    ,Auth.getProfile().mseg_espera_token); 
  }
}

cerrarmensaje_token=()=>{
  Auth.logout()
  clearInterval(token_interval)
  clearTimeout(setTimeout_token)
  this.setState({open_mensaje_token: false,isLoggin:false})
}

continuar_token=()=>{
  clearTimeout(setTimeout_token)

  this.setState({ open: true }, ()=>{
  try{
  new Request.post(`${globales.ip}/renovar_token`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({username: Auth.getProfile().user,sucursal: Auth.getProfile().sucursal,descrip_sucursal:Auth.getProfile().descrip_sucursal })
    .retry(0)
    .timeout({ response: 30000, deadline: 60000, }) 
    .end((err, res) => {

      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        { 
          this.setState({open: false})
          return;  
        }       
        this.setState({open: false})
        funciones.showToast('e', 'Problemas de conexión'); 
      }
      if(res!==undefined){
      localStorage.setItem('id_token', res.text.replaceAll('"',''))
      this.setState({open_mensaje_token: false,open: false})
      }

    })
  }
  catch(ex){
    this.setState({open: false})
    funciones.showToast('e', 'Problemas de conexión'); 
  }
  })
}

abrirmanual=(pagina)=>event=>{
 var url='Manuales/'+pagina+'.pdf'
 if(movil)
 window.open(url, "Manual de Usuario", "width=100%")
 else
 this.setState({open_manual: true,pdf: url})
}

cerrarmanual=()=>{
  this.setState({open_manual: false,pdf: ''})
}

changeswitch_publicaciones=(checked)=>{
  this.setState({switch_publi: checked})
  if(this.state.i===0 && !movil)
  window.location.reload();
}

/*                                                                 RENDER                                                */
render() {
  const { redirect } = this.state;
  let _this = this;
  var arr_filtro=[];

  const botones_bloqueo =[
    {icono: 'Close', nombre: 'Cerrar' ,onclick: this.cerrarmodal_bloqueo(), display:'auto', color: 'red'},
  ]
  const botones_token = [
    {icono: 'Close', nombre: 'Cerrar' ,onclick: this.cerrarmensaje_token, display:'auto', color: 'red'},
    {icono: 'CheckCircle', nombre: 'Continuar' ,onclick: this.continuar_token
    , display:'auto', color: 'green'},
  ]

  var d;
  if(localStorage.getItem('Tabs_user')===null){
    d=''
  }
  else{
    var arrtabs
    arrtabs= localStorage.getItem('Tabs_user')===null? []:JSON.parse(localStorage.getItem('Tabs_user'))
    if(arrtabs.filter(busqueda2 =>busqueda2.usuario.match(this.state.info.user)).length>0){
      arrtabs.map((item,index) =>{
        if (item.usuario===this.state.info.user)
        {
          d= item.tabs.length;
        }
        return '';
      })
    }
  }

  if (redirect===true) {
    this.lista_tab=[];
    this.lista_tabpanel=[];
    _this.setState({Body: [], Bodytab: [], i: 0})
      return <Redirect to='/login'/>;
  }


  if (this.state.isLoggin === true)
  {
  return (
    <div ref={this.div_principalRef} className={'Div-principal'} >
      <MuiThemeProvider theme={theme}>
      <Mensajes pagina='Principal' usuario={this.state.info.user} plataforma={this.state.info.plataforma}/>
      <Backdrop className='Backdrop-general' open={this.state.open}><CircularProgress color="inherit" /></Backdrop>

      {/*------------------------------------------DIALOG MANUAL PARA USUARIO----------------------------------------------*/}

      <Dialog open={this.state.open_manual} maxWidth='lg' fullWidth={true} fullScreen TransitionComponent={Transition} classes = {{ paper: 'Dialog-manual'}}>
      <AppBar color="primary" className='Aappbar_dialogmanual'>
            <Toolbar variant="dense" style={{ minHeight:'auto',padding:2,paddingLeft:20}}>
              <IconButton size="small" className='IconButton_dialogmanual' onClick={this.cerrarmanual} ><Iconos fontSize='small' icono='Close' /></IconButton>
              <Typography variant="h6" className='Typography_dialogmanual'>
                   Manual para Usuario 
              </Typography> 
            </Toolbar>
      </AppBar>
      <DialogContent style={{padding: 0}} //className='DialogContent_dialogmanual'
      >
        <embed src={this.state.pdf} aria-labelledby='Manual' className='pdf_dialogmanual'/> 
      </DialogContent>
      </Dialog>

      {/*------------------------------------------DIALOG CONFIRMA TOKEN----------------------------------------------*/}

      <Dialog  className='Dialog_confirma' open={this.state.open_mensaje_token} maxWidth='sm' fullWidth={true} >
        <DialogTitle className='DialogTitle_confirma' style={{color:'black'}}>{Auth.getProfile().titulo_confirma_token}</DialogTitle>
        <DialogContent className='DialogContent_confirma'>
          {Auth.getProfile().mensaje_confirma_token}
        </DialogContent>
        <BarraBotones align='center' botones={botones_token}/>
      </Dialog>

      {/*------------------------------------------DIALOG BLOQUEO DE PAGINA----------------------------------------------*/}

      <Dialog open={this.state.open_bloqueo} onClose={this.cerrarmodal_bloqueo()} 
      TransitionProps={{ onEntering: this.onEntering }}
        className='Dialog_bloqueo' maxWidth={this.state.max_width_mensaje} fullWidth={true} >
        <DialogTitle className='DialogTitle_bloqueo' style={{color: this.state.color_titulo_mensaje,background: this.state.background_titulo_mensaje}}>
            {this.state.titulo_mensaje}
        </DialogTitle>
        <DialogContent style={{background: this.state.background_mensaje}} >
          <div style={{textAlign: this.state.alineacion_mensaje, color: this.state.color_mesaje}} dangerouslySetInnerHTML={{__html:this.state.mensaje}} />
        </DialogContent>
        <BarraBotones botones={botones_bloqueo} backgroundColor={this.state.background_mensaje} />
      </Dialog>

      {/*------------------------------------------FAB DE NOTIFICACIONES----------------------------------------------*/}

      {(movil||(window.innerWidth<900&&this.state.switch_publi))&&this.state.i===0?
        <Fab key={'Fab-MOVIL'}  onClick={_this.abrirmodal_principal()} color='primary' className={movil_ipad?'Fab_notificaciones_i':'Fab_notificaciones'}>
          <Badge color="error" badgeContent={_this.noti}> <Iconos fontSize='large' icono='Notification'/> </Badge>
        </Fab>:null
      }

      {/*------------------------------------------MENU----------------------------------------------*/}

      {!this.state.cargando?
      <Menus cuenta={_this.state.info.user} carrera={_this.state.info.CARRERA} logout={_this.handleClick_1} cargar={_this.cargarstate} 
        plataforma={_this.state.info.plataforma} nombre={_this.state.info.NOMBRE} sucursal={_this.state.info.sucursal}
        id_control_matricula={_this.state.info.ID_CONTROL_MATRICULA} descrip_sucursal={_this.state.info.descrip_sucursal}
        modulos={_this.state.info.modulos} foto={_this.state.info.foto} año={_this.state.info.año}
        Limpiar_Principal={this.Limpiar_Principal} changeswitch_publicaciones={this.changeswitch_publicaciones}
        switch={this.state.switch_publi} permisos_usuario={this.state.permisos_usuario}
      />:null
      }

      {/*------------------------------------------DIALOG TIPO DE NOTIFICACIONES----------------------------------------------*/}

      <Dialog open={this.state.open_filtro} onClose={this.cerrarmodal()} disableEnforceFocus disableAutoFocus aria-labelledby="alert-dialog-slide-title" fullWidth= {true} maxWidth={'xs'} classes={{paper:'Paper_filtro'}} className='Dialog_tiponoti'>
      <DialogTitle className='DialogTitle_tiponoti'>
      <AppBar className='AppBar_tiponoti' color='primary' >
          <Toolbar  key="Toolbarnoti" variant="dense" className='Toolbar_tiponoti'>
            <Typography className='Typography_tiponoti' component={'span'} variant="subtitle2" align='center'>Tipo de Notificación</Typography>
            <IconButton onClick={this.cerrarmodal()} className='IconButton_tiponoti'><Iconos fontSize='small' icono='Close'/></IconButton>
          </Toolbar>
      </AppBar>
      </DialogTitle>
      <DialogContent className='DialogContent_tiponoti'> 
      <FormControl component="fieldset"  className='FormControl_tiponoti'>
          <RadioGroup aria-label="Tipo" className='RadioGroup_tiponoti' name="Tipo" value={this.state.filtro} onChange={this.handleChange_filtro}>
          {
          this.state.notificaciones.map((text,index,array)=>(
           text.LADO==='D'?
           (() => {
             if(arr_filtro.filter(busqueda2 => busqueda2===text.TIPO).length>0)
              return ;
             else{
             arr_filtro.push(text.TIPO)
             return (<div key={'divfiltro-'+index.toString()} className='Div_radiotiponoti'>
                        <Avatar className='Avatar_radiotiponoti' style={{backgroundColor: text.COLOR==='white'?'default':text.COLOR}} >
                          {text.MOSTRAR_ICONO?<Iconos fontSize='small' icono={text.NOM_ICONO} />:null}{text.MOSTRAR_ICONO?'':text.LETRAS}
                        </Avatar>
                        <FormControlLabel key={index.toString()} value={text.TIPO} control={<Radio />} label={text.TIPO}  style={{marginLeft:1}} />
                        <Divider variant={'fullWidth'} style={{backgroundColor: 'grey'}} />
                      </div>
             )}})():''
          ))}
          <div className='Div_radiotodo'><Avatar className='Avatar_radiotiponoti'><Iconos fontSize='small'  icono={'Notification'} /></Avatar>
            <FormControlLabel key='all' value={'all'} control={<Radio />} label={'Todo'} style={{marginLeft:1}}/>
          </div>
          </RadioGroup>
      </FormControl>
      </DialogContent>
      </Dialog>

      {/*------------------------------------------DIALOG ABRIR IMAGEN----------------------------------------------*/}

      <Dialog classes = {{ paper: 'paper_imagen'}}   open={this.state.open_imagen} onClose={this.cerrar_imagen()} fullScreen={true} >
      <AppBar position='relative' className='AppBar_imagen'>
            <Toolbar  key="Toolbarnoti" variant="dense" className='Toolbar_imagen'>
            <IconButton onClick={this.cerrar_imagen()} className='IconButton_imagen'>
              <Iconos fontSize='small' icono='Close'/></IconButton>
            </Toolbar>
      </AppBar>
      <DialogContent className='DialogContent_imagen'>
          <CardMedia className='media_imagen' component='img'  image={this.state.image} />
      </DialogContent>
      </Dialog>

      {/*------------------------------------------DIALOG NOTIFICACIONES----------------------------------------------*/}

      <Dialog open={this.state.open_modal}onClose={this.cerrarmodal()} disableEnforceFocus  disableAutoFocus aria-labelledby="alert-dialog-slide-title" fullWidth= {true} fullScreen= {movil_pequeño?true:false} maxWidth={movil_ipad?'sm':'xs'} classes = {{ paper: movil?'paper2_m':'paper2'}} className='Dialog_noti'>
      <DialogTitle className='DialogTitle_noti'>
        <AppBar className='AppBar_noti' color='primary' ><Toolbar  key="Toolbarnoti" variant="dense" className='Toolbar_noti'>
              <Typography className='Typography_noti' variant="subtitle2" align='center'>Notificaciones</Typography>
              <IconButton onClick={this.cerrarmodal()} className='IconButton_noti'><Iconos fontSize='small' icono='Close'/></IconButton>
        </Toolbar></AppBar>
      </DialogTitle>
      <DialogContent className='DialogContent_noti'> 
            <div className={movil_pequeño?'DivContent_noti_m':'DivContent_noti'}>
            {this.state.notificaciones!==null?
              this.state.notificaciones.map((text,index,array)=>(
                text.LADO==='D'?
                  <div className='Div_map' key={'D-'+index.toString()}>
                    <Typography align={text.ALINEACION_TITULO} className='Typography_maptitulo' variant='h6'>
                      {text.TITULO}
                    </Typography>
                    {//text.TITULO!==''?<Divider variant='middle' className='Divider_map'/>:null
                    }
                    <div className='Div_mapcontenido'>
                      <Avatar className='Avatar_mapcontenido' style={{backgroundColor: text.COLOR==='white'?'default':text.COLOR}}>{text.MOSTRAR_ICONO?<Iconos fontSize='small' icono={text.NOM_ICONO} />:null}{text.MOSTRAR_ICONO===true?'':text.LETRAS}</Avatar>
                        <Typography className='Typography_mapcontenido' align={text.ALINEACION_DESCRIPCION}
                      dangerouslySetInnerHTML={{__html:text.DESCRIPCION}}
                      />
                    </div>
                    <Divider variant='middle' className='Divider_map'/>
                  </div>
              :'')):''
            }
              </div>
          </DialogContent>
        </Dialog>

        <LinearProgress  className='LinearProgress' hidden={!_this.state.cargando} />

{/*------------------------------------------DIALOG DE PAGO----------------------------------------------*/}
<Dialog open={this.state.open_dialog_pago} aria-labelledby="alert-dialog-slide-title" fullWidth= {true} fullScreen= {movil_pequeño?true:false} maxWidth={movil_ipad?'sm':'xs'} classes = {{ paper: movil?'paper2_m':'paper2'}}>   
        <DialogTitle><Typography component='span' variant='subtitle2'>Pago en línea</Typography>
               <IconButton className='closeButton' onClick={this.cerrarmodal_pago()} size="small">
                <CloseIcon fontSize="small" />
               </IconButton>
              </DialogTitle>
      <DialogContent> 
            
                          {this.state.msg_pago}
                        
      </DialogContent>
        </Dialog>

      {/*------------------------------------------DIV CONTENEDOR----------------------------------------------*/}

      <div className='div-contenedor' style={{overflowY: this.state.i>0?'hidden':'auto' }}>
      <Grid container id={'grid principal'} >  

      {/*------------------------------------------BARRA DE TABS----------------------------------------------*/}

      <Grid item xs={12}>
        {_this.state.cargando?
        <Grid container spacing={2} style={{marginTop:5,marginLeft:5}}>
        <Grid item xs={movil_pequeño?6:4}>
          <div align='center' style={{marginBottom:5}}>
          <Skeleton sx={{ bgcolor: 'black' }}
          variant="rect" width={'100%'} height={118} />
          </div>
          <div align='center'>
          <Skeleton sx={{ bgcolor: 'black' }}
          variant="rect" width={'100%'} height={50} />
          </div>
        </Grid>
        {!movil_pequeño?
        <Grid item xs={4}>
        <div align='center'>
        <Skeleton sx={{ bgcolor: 'grey.900' }}
        variant="rect" width={'100%'} height={118} />
         </div>
        </Grid>:null
        }
        {!movil_pequeño?
        <Grid item xs={4}>
        <div align='center'>
        <Skeleton sx={{ bgcolor: 'grey.900' }}
        variant="rect" width={'100%'} height={118} />
         </div>
        </Grid>:null
        }
        </Grid>
        :null 
        }
        {_this.state.i>0&&!_this.state.cargando?
        <AppBar className='Appbar-Tabs' >
        <Tabs centered={movil?false:true}
        variant={movil?"scrollable":(_this.state.i>6 && _this.state.info.plataforma===1)?"scrollable":"standard"}
          classes={{root: 'root_b', indicator: 'Indicator', scrollButtons: 'scrollButtons'}} orientation='horizontal' value={_this.state.value} className='className_tabs' onChange={_this.handleChange}
        >
          {_this.state.Bodytab.map((text,index, array)=>{
            return( <LinkTab key={'LT-'+text.pagina} className='Linktab_root' 
              classes={{wrapped: 'Linktab_wrapped', wrapper: _this.state.info.plataforma!==1?'Linktab_wrapper':'Linktab_wrapper_admin'
                  ,labelIcon: _this.state.info.plataforma!==1?'Linktab_label':'Linktab_label_admin'
                  ,selected: 'Linktab_selected'}} label={_this.confirma_nom(text.nombre)} label_completo= {text.nombre} 
                style={{maxWidth:movil_pequeño?'40%':movil_ipad?'20%':_this.state.info.plataforma!==1?'40%':'13%',minWidth:movil_pequeño?'40%':movil_ipad?'20%':_this.state.info.plataforma!==1?'40%':'13%',}}  
                icon={<div>
                        <GridListTileBar className='Linktab_root_grid'
                          titlePosition='top' style={{display:_this.state.info.plataforma!==1?'none':'auto'}}
                          actionIcon={<Iconos onClick={_this.quitartab_close(index)} icono={'Close'} className='Linktab_grid_icono_close'/>}
                        /><Iconos icono={text.icono} fontSize='small' className='Linktab_grid_icono'/>
                      </div> 
                    } value={index} {...a11yProps(index)}/>);
              })}
        </Tabs>
        </AppBar>:null
        }
      </Grid>

      {/*------------------------------------------GRID INICIO----------------------------------------------*/}

      <Grid item xs={12}> 
        <div ref={this.divRef} className='Div_ref'>
        <div className={movil?'Divsubref_m':'Divsubref'} style={{display:_this.state.i===0 && _this.state.cargando===false?'initial':'none'}}>
          
      {/*------------------------------------------Grid general de notificaciones y mensajes-----------------*/}
          
        <Grid container  spacing={4} className='Grid_contenedor' > 

      {/*-------------------------------------------WIDGETS---------------------------------------------------*/}

          <Grid item xs={movil?(movil_ipad&&Auth.getProfile().plataforma!==1?6:12):Auth.getProfile().plataforma===1?this.state.switch_publi?window.innerWidth<900?12:4:window.innerWidth<930&&window.innerWidth>800?6:9:3} 
          style={{paddingLeft:0,paddingRight:0,display:this.state.switch_publi||Auth.getProfile().plataforma!==1||movil?'auto':'flex'}}>
            {_this.state.cargando===false?
              <Widgets actualizarsaldopendiente={response_code} switch_publi={this.state.switch_publi} estado_refresh_widgets={this.estado_refresh_widgets} interval_widget={this.interval_widget}  key="Widgets" cargar={_this.cargarstate} AbrirImagen={this.AbrirImagen} plataforma={_this.state.info.plataforma} rol={_this.state.info.rol} id_control_matricula={_this.state.info.ID_CONTROL_MATRICULA}/>
            :null
            }
            {(movil_ipad||movil_pequeño)&&((Auth.getProfile().plataforma===1&&this.state.switch_publi)||Auth.getProfile().plataforma!==1)?
              <WidgetCalendario2 noti={this.noti}/>:null
            }
          </Grid>

      {/*-------------------------------------------PUBLICACIONES---------------------------------------------------*/}

  {this.state.switch_publi||Auth.getProfile().plataforma!==1?
  <Grid item className={movil_pequeño?'Grid_publicaciones_m':'Grid_publicaciones'} xs={movil||window.innerWidth<900?movil_ipad&&Auth.getProfile().plataforma!==1?6:12:Auth.getProfile().plataforma===1?5:6}>
    <Paper className='Paper_publicaciones' style={{display: this.state.notificaciones.filter(busqueda2 => busqueda2.LADO==='I').length>0?'inline':'none'}}>
    {this.state.notificaciones!==null?
      this.state.notificaciones.map((text,index,array)=>{
        var url 
        if(text.LADO==='I' && text.CARD===1) {
          try { 
            url = '/Multimedia/Publicaciones/'+text.PATH
          }
          catch{ 
            url = '/Multimedia/404.png'
          }
        }
                  
    /*---------------------------------SI CARD ES FALSE SIGNIFICA QUE ES SOLO TEXTO-----------------------------------------------------------*/

      return(
        text.LADO==='I'?text.CARD===0? 
          <div key={'DIV-'+index.toString()}  className='Div_publicaciones_map'>
            <Typography className='Typography_publicacionestitulo' align={text.ALINEACION_TITULO} variant='h5'>{text.TITULO} </Typography>
              <Typography className='Typography_publicacionesdescripcion' component='div' align={text.ALINEACION_DESCRIPCION} variant={text.VARIANT_DESCRIPCION}>
                <div dangerouslySetInnerHTML={{__html:text.DESCRIPCION}}/>
              </Typography>
            {text.DIVIDER===1?<Divider className='Divider_publicaciones' variant={'middle'}/>:null}
          </div>
        :
        <div key={'DIV-'+index.toString()} >
          <Card elevation={11} className={movil?'Card_publicaciones_m':'Card_publicaciones'} style={{background:text.COLOR_CARD_GENERAL,boxShadow:text.BCG}} >
          {text.CARD_MEDIA===0 && text.CARD_HEADER===0?<Typography align={text.ALINEACION_TITULO} className='Typography_noheader' variant='h5'>{text.TITULO} </Typography>:null}
          {text.CARD_HEADER===1?
            <CardHeader avatar={
            <Avatar style={{display:text.AVATAR===1?'auto':'none',backgroundColor: text.COLOR}}>
              {text.MOSTRAR_ICONO?<Iconos fontSize='small' icono={text.NOM_ICONO} />:null}{text.MOSTRAR_ICONO?'':text.LETRAS}
            </Avatar>}
            subheaderTypographyProps={{color: text.COLOR_CARD_HEADER==='#000000'?'inherit':'textSecondary'}}
            title={text.TITULO} subheader={text.SUBTITULO_CARD}
            style={{backgroundColor: text.COLOR_CARD_HEADER,color: text.COLOR_LETRA_HEADER}}
            />:null
          }

    {/*------------------------------------------------CARD MEDIA  'video', 'audio', 'picture', 'iframe', 'img'--------------------------*/}
            
      {text.CARD_MEDIA===1?
        <CardActionArea onClick={text.NOM_COMPONENT==='img'?this.AbrirImagen(url):()=>{}}>
          <CardMedia component={text.NOM_COMPONENT} className='CardMedia' src={text.PATH===undefined?'':text.PATH} title={text.TITULO} image={text.NOM_COMPONENT==='iframe'?'':url} controls/>
        </CardActionArea>:null
      }

    {/*------------------------------------------------LIKE, NO LIKE, CON CARD MEDIA TRUE------------------------------------------------*/}  
      
      {text.M===1?text.CARD_MEDIA===1?
      <div>
        <Divider variant={'middle'} className='Divider_like'/>
        <CardActions disableSpacing style={{padding: 4, backgroundColor:text.COLOR_CARD_ACTION }}>
          <FormControlLabel
            control={<IconButton style={{padding: 4}} disabled={this.state.likes.find(element => element === text.ID)?true:false} onClick={this.clicklike(text.ID)}>
                      <Iconos color={usuario.like===null?'disabled':usuario.like.find(element => element.ID === text.ID && element.VALUE===1)?'primary':'disabled'}//color={text.LIKES===1?'primary':'disabled'} 
                      icono='Like'/>
                     </IconButton>
                    } label="Me gusta"  className='FormControlLabel_like'
          />

    {/*------------------------------------------------NO LIKE---------------------------------------------------------------------------*/}  

      {text.NM===1?
      <FormControlLabel
        control={<IconButton style={{padding: 4}} disabled={this.state.likes.find(element => element === text.ID)?true:false} onClick={this.clicknotlike(text.ID)}>
                  <Iconos color={usuario.like===null?'disabled':usuario.like.find(element => element.ID === text.ID && element.VALUE===0)?'error':'disabled'}
                  //color={text.LIKES===0?'error':'disabled'} 
                  icono='NotLike'/>
                </IconButton>
                } label="No me gusta" className='FormControlLabel_nolike'
      />:null
      }
      </CardActions>
      </div>
      :null:null
      }

    {/*------------------------------------------------------CARD CONTENT---------------------------------------------------*/}

      {text.CARD_CONTENT===1?
      <CardContent className='CardContent' style={{color: text.COLOR_LETRA_CONTENT,backgroundColor: text.COLOR_CARD_CONTENT}}>
        {text.DESCRIPCION!==undefined && text.DESCRIPCION!==''?    
          <div style={{overflowY:'auto',maxHeight: text.HEIGHT_DESCRIPCION,textAlign: text.ALINEACION_DESCRIPCION, color: text.COLOR_LETRA_CONTENT}} dangerouslySetInnerHTML={{__html:text.DESCRIPCION}} />
        :null
        }   
      </CardContent>:null
      }

    {/*------------------------------------------------------LIKE, NO LIKE, CARD MEDIA ES FALSE-----------------------------*/}  

      {text.M===1?text.CARD_MEDIA===0?
      <div>
      <Divider variant={'middle'} className='Divider_nomedia'/>
      <CardActions disableSpacing style={{padding: 4, backgroundColor:text.COLOR_CARD_ACTION }}>
        <FormControlLabel
          control={<IconButton style={{padding: 4}} disabled={this.state.likes.find(element => element === text.ID)?true:false} onClick={this.clicklike(text.ID)}>
            <Iconos  color={usuario.like===null?'disabled':usuario.like.find(element => element.ID === text.ID && element.VALUE===1)?'primary':'disabled'}
            //color={text.LIKES===1?'primary':'disabled'} 
            icono='Like'/></IconButton>}
          label="Me gusta"  className='FormControlLabel_nomedia'
        />

    {/*-------------------------------------------------------NO LIKE-------------------------------------------------------*/}   

      {text.NM===1?
      <FormControlLabel
        control={<IconButton style={{padding: 4}} disabled={this.state.likes.find(element => element === text.ID)?true:false} onClick={this.clicknotlike(text.ID)}>
                 <Iconos color={usuario.like===null?'disabled':usuario.like.find(element => element.ID === text.ID && element.VALUE===0)?'error':'disabled'}
                 //color={text.LIKES===0?'error':'disabled'} 
                 icono='NotLike'/>
                </IconButton>
                }
        label="No me gusta"  style={{borderLeft: '1px solid #E2E2E2',color: 'grey',marginRight:10,paddingLeft:10}}
      />
      :null
      }
      </CardActions>
      </div>
      :null:null
      }
    </Card>  
    </div>
    :'')
    }):''
    }
    </Paper>
    </Grid>:null
    }

   {/*------------------------------------------------------GRID NOTIFICACIONES---------------------------------------------*/} 

    {!movil&&window.innerWidth>=828&&(!this.state.switch_publi||window.innerWidth>915)?
    <Grid item xs={window.innerWidth<900?6:3} className='Grid_notificaciones'> 
      <Paper className={this.noti===0?'Paper-nd':'Paper-nd-noti'}> 
            <AppBar  className='AppBar-nd'>
              <Toolbar variant='dense'>
                <Badge  color="error" badgeContent={this.noti}/>
                <Typography className={'Typography-appbar'} variant='subtitle2' >{'Notificaciones'}</Typography>
                <IconButton className='IconButton-nd' disabled={this.noti===0?true:false}  onClick={this.click_filtro_noti}> <Iconos fontSize='small' icono='Filter' /></IconButton>
              </Toolbar>
            </AppBar>
        <div className='DivContent_noti'>
        {this.state.notificaciones!==null?
          this.state.notificaciones.map((text,index,array)=>(
            text.LADO==='D' && (this.state.filtro==='all'||text.TIPO===this.state.filtro)?
            <div key={'DI-'+index.toString()} style={{marginRight:5}}>
              <Typography align={text.ALINEACION_TITULO} className={'Typography-titulo'} variant='h6'>
                {text.TITULO}
              </Typography>
              <div className='Div-sub-nd'>
                <Avatar className='Avatar-nd' style={{backgroundColor: text.COLOR==='white'?'default':text.COLOR}}>
                  {text.MOSTRAR_ICONO?<Iconos fontSize='small' icono={text.NOM_ICONO} /> :null}{text.MOSTRAR_ICONO?'':text.LETRAS}
                </Avatar>
                <Typography className='Typography-descripcion' align={text.ALINEACION_DESCRIPCION}
                 dangerouslySetInnerHTML={{__html:text.DESCRIPCION}}
                 />
              </div>
              <Divider variant='middle' className='Divider_map'/>
            </div>
          :''
          )):''
        }
        </div>
    </Paper>
    <WidgetCalendario2 noti={this.noti}/>
    </Grid>:null
    }       
    </Grid>
    </div>

  {/*--------------------------------------------------------------PAGINAS-----------------------------------------------*/}

    {_this.state.i!==0 && _this.state.cargando===false?
    _this.state.Body.map( function(text,index) {
      var nindex=text.pagina==='0'||text.pagina===undefined?index.toString():''
      return(
        <TabPanel key={'TP-'+text.pagina+nindex} value = {_this.state.value} index={index}>

          {/*------------------------------------------------------------BARRA----------------------------------------------------*/}

          <AppBar className={'Appbar-pagina'} //color="default"
          >
            <Toolbar variant="dense" className={movil_pequeño?'Toolbar-pagina-m':'Toolbar-pagina'}>
            {text.manual //&& !movil
            ?<Tooltip title="Manual para Usuario"><IconButton size='small' onClick={_this.abrirmanual(text.pagina)} color="primary"  ><Iconos icono='HelpIcon'/></IconButton></Tooltip>:null}
            <Typography  className={movil_pequeño?'Typography-descipcion-m':'Typography-descipcion-p'}>{text.descripcion}</Typography>
            <Fab key={'Fab-'+text.pagina} onClick={_this.abrirmodal()} className={movil_pequeño?movil_ipad?'Fab-Appbar-i':'Fab-Appbar-m':'Fab-Appbar-p'} style={{visibility: d>0?'visible':'hidden'}}>
              <Badge  color="error" badgeContent={_this.noti}><Iconos icono='Notification'/></Badge>
            </Fab>
            <IconButton size='small' onClick={_this.quitartab} disabled={!_this.state.hiddenLinear||!_this.state.hiddenCircular} className={'Boton-cerrar-appbar'} ><Iconos icono='Close'/></IconButton>
            </Toolbar>
          </AppBar>

          {/*------------------------------------------------------------------PAGINA--------------------------------------------*/}

          <div className={movil_pequeño?'Div-pagina-m':'Div-pagina'} key={'div-'+text.pagina}>                 
            <LinearProgress className={'LinearProgress'} key={'LPR-'+text.pagina} hidden={_this.state.hiddenLinear}/>
            <Backdrop className='Backdrop-pagina'  open={!_this.state.hiddenCircular}><CircularProgress color="inherit" /></Backdrop>
            <div id= 'divbarra' className={'Div-pagina2'}>
              <Pagina clearResponseCode={_this.clearResponseCode} response_code={response_code} cerrarventana={_this.quitartab} cargar={_this.cargarstate} permisos_paginas={_this.state.permisos_paginas} actualizarcircular={_this.actualizarcircular} actualizarbarra={_this.actualizarbarra} mensaje={_this.state.mensaje} bloqueo={_this.state.bloqueo} movil_pequeño={movil_pequeño} index={index} value={_this.state.value} pagina={text.pagina} reporte={text.reporte}/>
            </div>
          </div>
        </TabPanel>  
    );
    }):null
    }
    </div>

  </Grid>
</Grid>
</div>
</MuiThemeProvider>
</div>
  ); /// finaliza return
}
else if (this.state.isLoggin === false)
{
  this.lista_tab=[];this.lista_tabpanel=[];
  this.noti=0;this.renderizo=0;this.interval_widget=0;this.estado_refresh_widgets=0;
  lista_tab=[];lista_tabpanel=[];
  clearInterval(token_interval)
  clearInterval(notificaciones_interval)
  clearTimeout(setTimeout_token)

  Auth.logout()
  return ((<Redirect to="/login"/>));
}
return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles